import React, { useMemo, useCallback } from 'react';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';

import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import Snackbar from 'components/DesignSystem/Snackbar';
import useVariables from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useVariables';

export default function Variables() {
  const { variables, selectedVariable, setSelectedVariable } = useVariables();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('variables-accordion'), []);
  const setSelectedVariableAndClose = useCallback((newVariable: string) => {
    setSelectedVariable(newVariable);
    closeAccordion();
  }, [setSelectedVariable, closeAccordion]);

  return (
    <Accordion.Item eventKey="variables" id="variables-accordion">
      <Accordion.Header>Variável</Accordion.Header>
      <Accordion.Body>
        {variables.length === 0 && (
          <Snackbar>Nenhuma variável disponível para os parâmetros especificados.</Snackbar>
        )}
        {variables.map((variable) => (
          <RadioButton
            key={variable.value}
            label={variable.label}
            checked={selectedVariable === variable.value}
            onChange={() => setSelectedVariableAndClose(variable.value)}
            className="my-2"
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
